import React, { SyntheticEvent, useState } from 'react';
import classnames from 'classnames';
import styles from './index.module.scss';

export type ProductTab = {
  name: string;
  anchorElementId: string;
};
type ProductTabListType = {
  tabList?: ProductTab[];
  className?: string;
};
const ProductTabList = React.forwardRef<HTMLElement, ProductTabListType>(({ tabList = [], className }, ref) => {
  const [currentTabIndex, setCurrentTabIndex] = useState(0);
  return (
    <section ref={ref} className={classnames(styles.tabList, className)}>
      {tabList.map((item, index) => (
        <li
          key={item.anchorElementId}
          onClick={(e: SyntheticEvent<HTMLLIElement>) => {
            e.preventDefault();
            const el = document.querySelector(item.anchorElementId);
            el.scrollIntoView({ behavior: 'smooth' });
            setCurrentTabIndex(index);
          }}
          className={classnames(styles.tab, { [styles.activeTab]: currentTabIndex === index })}
        >
          {item.name}
        </li>
      ))}
    </section>
  );
});
export default ProductTabList;
